/**
 * Line colours of the org chart, chosen by hand: per line (from the line's own toolbar) or per
 * kind of line (from the legend). The dash (Komplementär solid, Kommanditist dashed) keeps the
 * meaning; the colour is free. Palette: the design system's badge colours plus Juliette petrol.
 */

export type LineKind = 'general' | 'limited' | 'plain';

export interface LineColorOption {
  value: string;
  label: string;
}

export const LINE_COLORS: LineColorOption[] = [
  { value: '#629d37', label: $localize`:@@colorGreen:Green` },
  { value: '#005763', label: $localize`:@@colorPetrol:Petrol` },
  { value: '#0984c2', label: $localize`:@@colorBlue:Blue` },
  { value: '#7a5ccf', label: $localize`:@@colorPurple:Purple` },
  { value: '#c0392b', label: $localize`:@@colorRed:Red` },
  { value: '#e67e22', label: $localize`:@@colorOrange:Orange` },
  { value: '#f5b937', label: $localize`:@@colorYellow:Yellow` },
  { value: '#7b7b7b', label: $localize`:@@colorGrey:Grey` },
];

/** Colour per line id, set on the line itself. */
export type LineColors = Record<string, string>;
/** Colour per kind of line, set in the legend. */
export type KindColors = Partial<Record<LineKind, string>>;

export function lineKind(role: string | null | undefined): LineKind {
  return role === 'general_partner' ? 'general' : role === 'limited_partner' ? 'limited' : 'plain';
}

/** The line's own colour, else its kind's, else null (the standard look from the CSS). */
export function lineColor(id: string, role: string | null | undefined, lineColors: LineColors, kindColors: KindColors): string | null {
  return lineColors[id] ?? kindColors[lineKind(role)] ?? null;
}
